// Icon and color per delivery status id of the latest WhatsApp message; the labels come from the API.
export const WHATSAPP_DELIVERY_STATUSES = {
  sending: { icon: "mdi-clock-outline", color: "#9CA3AF" },
  sent: { icon: "mdi-check", color: "#6B7280" },
  delivered: { icon: "mdi-check-all", color: "#6B7280" },
  read: { icon: "mdi-check-all", color: "#2563EB" },
  not_on_whatsapp: { icon: "mdi-close", color: "#DC2626" },
  opted_out: { icon: "mdi-close", color: "#DC2626" },
  failed: { icon: "mdi-close", color: "#DC2626" },
};

export const WHATSAPP_FAILURE_STATUSES = [
  "not_on_whatsapp",
  "opted_out",
  "failed",
];
